<div class="submit-container" data-testid="job-submission-container">
  <div class="submit-confirmation">
    <div class="message-content">
      @if (isOnline) {
        @if (!submissionFinished) {
          <div class="spinning" data-testid="job-submission-container-uploading">
            <p-progress-spinner ariaLabel="Uploading your work" />
          </div>
          <a>Uploading your work</a>
        }
        @else if (maxTimeoutElapsed) {
          <img class="icon"
               src="assets/icons/sync-info.svg"
               alt="upload in progress" />
          <p-tag severity="info"
                 value="Upload in Progress"
                 [rounded]="true"
                 data-testid="job-submission-badge-in-progress" />
          <div class="confirmation-message" data-testid="job-submission-text-in-progress">
            <div>
              Your work is currently uploading.
            </div>
            <div>
              To ensure your work is saved, please <strong>keep this app open</strong> until the upload is 100% complete.
            </div>
          </div>
          <img src="assets/icons/divider.svg"
               alt="divider"
               class="divider" />
          <button class="submit-button"
                  (click)="clickOnDone()"
                  data-testid="job-submission-btn-done">
            Go to schedule
          </button>
        }
        @else {
          <img class="icon"
               src="assets/icons/check-circle-outline.svg"
               alt="Looking great!" />
          <p-tag severity="success"
                 value="Uploaded"
                 [rounded]="true"
                 data-testid="job-submission-badge-uploaded" />
          <div class="confirmation-message" data-testid="job-submission-text-uploaded">
            <div>
              Your work has been <strong>uploaded successfully</strong>.
            </div>
            <div>
              You can now view the finalized report on your schedule or in the complete tab.
            </div>
          </div>
          <img src="assets/icons/divider.svg"
               alt="divider"
               class="divider" />
          <button class="submit-button"
                  (click)="clickOnDone()"
                  data-testid="job-submission-btn-done">
            Go to schedule
          </button>
        }
      }
      @else {
        <img class="icon"
             src="assets/icons/sync-warn.svg"
             alt="upload pending" />
        <p-tag severity="warn"
               value="Upload Pending"
               [rounded]="true"
               data-testid="job-submission-badge-pending" />
        <div class="confirmation-message" data-testid="job-submission-text-offline">
          <div>
            Your work is <strong>saved to this device</strong>, but the upload is paused because you are currently offline.
          </div>
          <div>
            To upload work, connect to the internet and <strong>keep this app open</strong>.
          </div>
        </div>
        <img src="assets/icons/divider.svg"
             alt="divider"
             class="divider" />
        <button class="submit-button"
                (click)="clickOnDone()"
                data-testid="job-submission-btn-done">
          Go to schedule
        </button>
      }
    </div>
  </div>
</div>
